module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, [_c('div', {
    key: 0,
    staticClass: "container-fluid",
    attrs: {
      "id": "bottomCTA",
      "key": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_c('div', {
    staticClass: "footer-left-246"
  }, [_c('a', {
    attrs: {
      "href": "https://www.kingscamps.org/kings-camps-policies/",
      "target": "_blank"
    }
  }, [_vm._v("\n                Camp Policies\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-left-main"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_copyright)
    }
  }), _vm._v(" "), _vm._l((_vm.$root.config.footer_nav_links), function(link) {
    return _c('a', {
      attrs: {
        "href": link.location,
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s(link.title)
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "contact-meta"
  }, [_c('div', {
    staticClass: "phone-icon hidden-xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-number"
  }, [_c('span', {
    staticClass: "hidden-md hidden-lg hidden-sm",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_telephone_number_prefix)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs",
    domProps: {
      "innerHTML": _vm._s(_vm.locale.text_telephone_number_prefix)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "footer-phone-246",
    attrs: {
      "href": 'tel:0151 433 6941'
    }
  }, [_c('b', {
    domProps: {
      "innerHTML": _vm._s('0151 433 6941')
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "footer-phone-main",
    attrs: {
      "href": 'tel:' + _vm.$root.config.kings_phone_number
    }
  }, [_c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.$root.config.kings_phone_number)
    }
  })])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-072059b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = 154
// module chunks = 0